<template>
  <div>Notification View</div>
</template>

<script>
export default {
  name: "NotificationView",
};
</script>
